function HomeInfo() {
    return (
        <div className="absolute h-fit top-60 left-32">
            <span className="text-heading font-barlow  text-[#D0D6F9] ">SO, YOU WANT TO TRAVEL TO</span>
            <h1 className="text-space font-bellefair text-white w-fit h-fit">SPACE</h1>
            <p className="w-para text-para font-bellefair text-[#D0D6F9]">Let’s face it; if you want to go to space, you might as well genuinely go to outer space and not hover kind of on the edge of it. Well sit back, and relax because we’ll give you a truly out of this world experience!</p>
        </div>
    );
}
export default HomeInfo;